<template>
  <div class="cancel-paid-plan-confirm-page">
    <sub-header-section :pageTitle="$tc('CancelPaidPlan.EditPage.title')" />

    <cancel-paid-plan-confirm-pane
      @handlerSubmit="moveToCancelPaidPlanComplete"
      @handlerCancel="handlerCancel"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import CancelPaidPlanConfirmPane from '@/components/pc/MyPage/CancelPaidPlanPage/CancelPaidPlanConfirmPane.vue'

/**
 * 有料会員解約 確認ページ
 */
export default defineComponent({
  name: 'CancelPaidPlanConfirmPage',
  components: {
    SubHeaderSection,
    CancelPaidPlanConfirmPane,
  },
  methods: {
    /**
     * 登録完了ページに遷移する
     */
    moveToCancelPaidPlanComplete() {
      this.$router.replace({ name: 'CancelPaidPlanCompletePage' })
    },
    /**
     * プラン選択画面へ遷移する
     */
    handlerCancel() {
      this.$router.replace({ name: 'CancelPaidPlanEditPage' })
    },
  },
})
</script>

<style lang="scss" scoped>
.cancel-paid-plan-confirm-page {
  &__header {
    position: sticky;
    top: 0;
  }
}
</style>
